import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'includes', })
export class IncludesPipe implements PipeTransform {
    transform(haystack: string, needle: string): boolean {
        return haystack.includes(needle);
    }
}
